export const StorageKey = {
  InstallerToken: 'ir',
  ImpersonateUserId: 'oe-imp',
  DeviceId: 'd',
  LoginAttemptId: 'la',
}

export type StorageKeyType = typeof StorageKey
